import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { cn, doEncryptLocal } from '@express-labs/raven-tools';
import { ProgressBar, Link } from '@express-labs/raven-ui';
import CircleProgressBar from '../CircleProgressBar';
import AListIcon from '../AListIcon';
import Slash from '../../Slash';
import s from './DynamicHeader.module.scss';
import getFromStorage from '../../../../../../helpers/storage/storage';
import routes from '../../../../../routes/routes';
import { LOCAL_STORAGE_SECRET } from '../../../../../../constants';

class DynamicHeader extends Component {
  static meta = {
    VERSION: '1.0.0',
  };

  static propTypes = {
    aListIconClassName: PropTypes.string,
    availableRewardsText: PropTypes.string,
    className: PropTypes.string,
    customerData: PropTypes.shape({
      loginStatus: PropTypes.bool,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      tierName: PropTypes.string,
      aList: PropTypes.bool,
      pointsBalance: PropTypes.number,
      pointsToNextTier: PropTypes.number,
      totalPointsForNextReward: PropTypes.number,
      totalPointsForAListReward: PropTypes.number,
      rewardAmountInCentsForNextReward: PropTypes.number,
      rewardAmountInCentsForAListReward: PropTypes.number,
      rewardCount: PropTypes.number,
      pointsTowardsAListStatus: PropTypes.number,
      pendingRewardsCount: PropTypes.number,
      rewardsTotal: PropTypes.number,
      loyaltyStatus: PropTypes.string,
      nextCreditCardHolder: PropTypes.bool,
    }).isRequired,
    isInsider: PropTypes.bool,
    loyaltyRewards: PropTypes.shape({
      rewardsTotal: PropTypes.number,
    }).isRequired,
    meterColor: PropTypes.string,
  };

  static defaultProps = {
    aListIconClassName: 'insiderClass',
    availableRewardsText: 'in available rewards',
    className: null,
    isInsider: false,
    meterColor: '#000000',
  };

  static getLocalStorageData = (key) => key && localStorage.getItem(key);

  constructor(props) {
    super(props);
    this.state = {
      warmCustomer: {
        firstName: 'Paige',
        aList: true,
        totalPointsForAListReward: 5000,
        pointsBalance: 1234,
        pointsToNextTier: 3766,
        rewardsTotal: 20,
        lastName: 'Other',
        totalPointsForNextReward: 2500,
      },
    };
  }

  componentDidMount() {
    if (window.hasStorage) {
      const encFirstName = DynamicHeader.getLocalStorageData('firstName');
      const decryptedFirstName = encFirstName
        && doEncryptLocal.doDecrypt(LOCAL_STORAGE_SECRET, encFirstName);
      const loyaltyWarmStateData = getFromStorage('loyaltyWarmStateData', {});
      const warmCustomer = {
        firstName: decryptedFirstName,
        ...loyaltyWarmStateData,
      };
      this.setState({ warmCustomer });
    }
  }

  render() {
    const {
      aListIconClassName,
      availableRewardsText,
      className,
      customerData,
      isInsider,
      loyaltyRewards,
      meterColor,
    } = this.props;
    const myData = this.state.warmCustomer.lastName ? this.state.warmCustomer : customerData;
    const {
      aList,
      totalPointsForAListReward,
      pointsBalance,
      pointsToNextTier,
      firstName,
      totalPointsForNextReward,
    } = myData;

    const { rewardsTotal } = loyaltyRewards;

    const hasRewards = rewardsTotal > 0;
    const leftClass = isInsider && !hasRewards ? 'leftInsiderNoRewards' : 'left';
    const rightClass = isInsider && !hasRewards ? 'rightInsiderNoRewards' : 'right';
    const getUserStatus = () => {
      if (!aList) {
        return (
          <>
            <CircleProgressBar
              goal={totalPointsForAListReward}
              completed={pointsBalance}
              aria-label="basic"
            />
            <p className={s.aListInfo}>
              {`${pointsToNextTier}pts`}
              <span className={s.text}>

                {' '}
                until A-List
              </span>
            </p>
          </>
        );
      }
      return (
        <>
          <AListIcon className={aListIconClassName} aria-label="aList" />
          <p className={s.aListInfo}>You are on the A-List!</p>
        </>
      );
    };
    const getReward = () => {
      if (hasRewards) {
        return (
          <div className={s.reward}>
            <span className={s.rewardAmount}>
              {`$${rewardsTotal}`}
              {' '}

            </span>
            {availableRewardsText}
            {' '}

            <Link className="linkDark" href={routes.myAccount.path}>
              See Details
            </Link>
          </div>
        );
      }
      return <div className={s.before} />;
    };
    const showName = () => {
      if (isInsider) {
        return (
          <div className={s.customer} data-qm-encrypt>
            Hi,
            {` ${firstName}`}
          </div>
        );
      }
      return (
        <div className={s.customer}>
          <span className={s.firstName} data-qm-encrypt>{firstName}</span>
          <Slash />
          <span className={s.points}>{pointsBalance}</span>
        </div>
      );
    };
    const pointsOperation = totalPointsForNextReward - pointsBalance;
    const sanitizedPointsForNextReward = pointsOperation > 0 ? pointsOperation : 0;
    return (
      <div className={cn(s.container, s[className])} aria-label="dynamic header">
        <div className={s[leftClass]}>
          {getReward()}
          {showName()}
          <ProgressBar
            className={s.progressBar}
            goal={totalPointsForNextReward}
            completed={pointsBalance}
            height={8}
            width={275}
            percentInContainer={70}
            backgroundColor="#e1e1e1"
            meterColor={meterColor}
          />
          <p className={s.info}>
            {`${sanitizedPointsForNextReward}pts`}
            <span className={s.text}>
              {' '}
              until next Reward
            </span>
          </p>
        </div>
        <div className={s[rightClass]}>{getUserStatus()}</div>
      </div>
    );
  }
}
export default DynamicHeader;
